module.exports = "/dist//vvsources.css";


//////////////////
// WEBPACK FOOTER
// ./hacks/vvsources.css
// module id = 304
// module chunks = 0